import { render, staticRenderFns } from "./TopKeywords.vue?vue&type=template&id=0ec1bbc9&scoped=true&"
import script from "./TopKeywords.vue?vue&type=script&lang=js&"
export * from "./TopKeywords.vue?vue&type=script&lang=js&"
import style0 from "./TopKeywords.vue?vue&type=style&index=0&id=0ec1bbc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1bbc9",
  null
  
)

export default component.exports